import React from 'react';
import style from './StickyFooter.module.scss';
import cx from 'classnames';
//dls
import { Svg16 as ArrowRight } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronRight';
import { Svg16 as ArrowLeft } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronLeft';
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// widgets
import AsyncButton from '@/widgets/AsyncButton';
//constants
import { DlsColorTokens } from '@/constants/DLSTokens';
import Tooltip from '@/components/Tooltip/Tooltip';
// store
import useConfigStore from '@/stores/Configs';
const StickyFooter = ({ onNext, onBack, backButtonLabel, nextButtonLabel, showBack, }) => {
    const { campaignOpDisabled, campaignOpDisabledCallout } = useConfigStore((state) => ({
        campaignOpDisabled: state.campaignOpDisabled,
        campaignOpDisabledCallout: state.campaignOpDisabledCallout,
    }));
    const nextBtnNode = (React.createElement("div", { className: style.nextButton },
        React.createElement(AsyncButton, { variant: 'primary', onClick: onNext, disabled: campaignOpDisabled },
            nextButtonLabel,
            React.createElement(ArrowRight, { className: style.nextIcon, fill: tokens.colors.chalk100 }))));
    return (React.createElement("footer", { className: style.footer },
        React.createElement("div", { className: cx(style.content, {
                [style.contentTwoButtons]: showBack,
            }) },
            showBack && (React.createElement(TextButton, { onClick: onBack, className: style.backButton, buttonSize: "medium", color: DlsColorTokens.primary },
                React.createElement(ArrowLeft, { className: style.backIcon, fill: "#F15700" }),
                backButtonLabel)),
            campaignOpDisabled ? (React.createElement(Tooltip, { content: campaignOpDisabledCallout, inline: false }, nextBtnNode)) : (nextBtnNode))));
};
export default StickyFooter;
